
  <g-img *ngIf="src" [src]="src">
    </g-img>
    <g-img *ngIf="!src" [src]="'assets/consumer/creator_profile.svg'"></g-img>
    <div class="text-container">
      <p class="title">{{title}}</p>
      <p class="subtitle">{{subtitle}}</p>
    </div>
